(function () {
  'use strict';

  angular
    .module('app.pages', [
      'app.page-contractors',
      'app.page-customer-employees',
      'app.page-customers',
      'app.page-dashboard',
      'app.page-emails',
      'app.page-project-attributes',
      'app.page-project-building-types',
      'app.page-project-document-templates',
      'app.page-project-indicator-templates',
      'app.page-project-part-act-remark-template-types',
      'app.page-project-part-act-remark-templates',
      'app.page-project-part-types',
      'app.page-project-parts',
      'app.page-project-types',
      'app.page-projector-employees',
      'app.page-projectors',
      'app.page-projects',
      'app.page-roles',
      'app.page-system',
      'app.page-user-certificates',
      'app.page-users'
    ]);
})();
